import { type AnyAction, combineReducers } from 'redux';

import {
    receivePremiumMediaStatus,
    receivePremiumMediaUsage,
} from 'js/src/data/premium-media/premium-media-actions';

export function total_active_credit_availability(state = 0, action: AnyAction) {
    if (receivePremiumMediaStatus.match(action)) {
        return action.payload.total_active_credit_availability;
    }
    return state;
}
export function total_active_credit_expense(state = 0, action: AnyAction) {
    if (receivePremiumMediaStatus.match(action)) {
        return action.payload.total_active_credit_expense;
    }
    return state;
}
export function credits_used_in_draft(state = 0, action: AnyAction) {
    if (receivePremiumMediaUsage.match(action)) {
        return action.payload.credits;
    }
    return state;
}

export const premium_media = combineReducers({
    total_active_credit_availability,
    total_active_credit_expense,
    credits_used_in_draft,
});

export type PremiumMediaState = ReturnType<typeof premium_media>;
